/**
 * Converts a decimal number to hexadecimal
 * @param decimal - The decimal number to convert
 * @returns The hexadecimal representation
 */
export const decimalToHex = (value: number | string | null): string => {
  if (value === null) {
    return '';
  }
  // Check if the value is already a hexadecimal string
  if (typeof value === 'string' && value.startsWith('0x')) {
    return value;
  }

  // Convert string numbers to actual numbers
  const numericValue = typeof value === 'string' ? parseFloat(value) : value;

  // Handle negative numbers
  if (typeof numericValue === 'number' && numericValue < 0) {
    return `-${decimalToHex(Math.abs(numericValue))}`;
  }

  // Convert to hexadecimal and remove the '0x' prefix
  return `0x${numericValue.toString(16)}`;
};

export const hexToDecimal = (
  value: string | number | null,
): number | string => {
  if (value === null) {
    return '';
  }

  // Check if the value is already a decimal number
  if (typeof value === 'number' || !value.startsWith('0x')) {
    return value;
  }

  // Remove any '0x' prefix if present
  const cleanHex = value.replace(/^0x/i, '');

  return parseInt(cleanHex, 16);
};
